export const isSupportedBrowser = () =>
  navigator.userAgent.indexOf('Chrome') > -1 &&
  navigator.userAgent.indexOf('Edg') < 1
